export interface ArtworkInfo {
  title: string;
  type: string;
  size: string;
  year: number;
}

export interface Image {
  id: string;
  url: string;
  title: string;
  year: string;
  fileNumber: number;
  orderIndex: number;
  artworkInfo?: ArtworkInfo;
}

export const artworkInfoMap: { [key: string]: ArtworkInfo } = {
  "2015-17.webp": {
    title: "Present Continuous 17",
    type: "oil on canvas",
    size: "P100, 1,620mm x 1,120mm",
    year: 2015,
  },
  "2017-28.webp": {
    title: "Present Continuous 28",
    type: "oil on canvas",
    size: "P50, 1,167mm x 803mm",
    year: 2017,
  },
  "2016-20.webp": {
    title: "Present Continuous 20",
    type: "oil on canvas",
    size: "P50, 1,167mm x 803mm",
    year: 2016,
  },
  "2016-19.webp": {
    title: "Present Continuous 19",
    type: "oil on canvas",
    size: "P50, 1,167mm x 803mm",
    year: 2016,
  },
  "2018-42.webp": {
    title: "Present Continuous 42",
    type: "oil on canvas",
    size: "F100, 1,620mm x 1,300mm",
    year: 2018,
  },
  "2016-18.webp": {
    title: "Present Continuous 18",
    type: "oil on canvas",
    size: "P100, 1,620mm x 1,120mm",

    year: 2016,
  },
  "2018-40.webp": {
    title: "Present Continuous 40",
    type: "oil on canvas",
    size: "P50, 1,167mm x 830mm",
    year: 2018,
  },
  "2016-21.webp": {
    title: "Present Continuous 21",
    type: "oil on canvas",
    size: "F100, 1,620mm x 1,300mm",
    year: 2016,
  },
  "2017-29.webp": {
    title: "Present Continuous 29",
    type: "oil on canvas",
    size: "F30, 910mm x 727mm",
    year: 2017,
  },
  "2017-31.webp": {
    title: "Present Continuous 31",
    type: "oil on canvas",
    size: "F4, 333mm x 242mm",
    year: 2017,
  },
  "2017-30.webp": {
    title: "Present Continuous 30",
    type: "oil on canvas",
    size: "F30, 910mm x 727mm",
    year: 2017,
  },
  "2017-33.webp": {
    title: "Present Continuous 33",
    type: "oil on canvas",
    size: "F4, 333mm x 242mm",
    year: 2017,
  },
  "2017-34.webp": {
    title: "Present Continuous 34",
    type: "oil on canvas",
    size: "F4, 333mm x 242mm",

    year: 34,
  },
  "2017-39.webp": {
    title: "Present Continuous 39",
    type: "oil on canvas",
    size: "F3, 273mm x 220mm",
    year: 2017,
  },
  "2017-32.webp": {
    title: "Present Continuous 32",
    type: "oil on canvas",
    size: "F6, 410mm x 318mm",
    year: 2017,
  },
  "2016-22.webp": {
    title: "Present Continuous 22",
    type: "oil on canvas",
    size: "F12, 606mm x 500mm",
    year: 2016,
  },
  "2016-23.webp": {
    title: "Present Continuous 23",
    type: "oil on canvas",
    size: "F12, 606mm x 500mm",
    year: 2016,
  },
  "2017-27.webp": {
    title: "Present Continuous 27",
    type: "oil on canvas",
    size: "F15, 652mm x 530mm",
    year: 2017,
  },
  "2018-41.webp": {
    title: "Present Continuous 41",
    type: "oil on canvas",
    size: "P50, 1,167mm x 803mm",
    year: 2018,
  },
  "2016-25.webp": {
    title: "Present Continuous 25",
    type: "oil on canvas",
    size: "F6, 318mm x 410mm",
    year: 2016,
  },
  "2016-24.webp": {
    title: "Present Continuous 24",
    type: "oil on canvas",
    size: "F120, 1,303mm x 1,940mm",
    year: 2016,
  },
  "2017-36.webp": {
    title: "Present Continuous 36",
    type: "oil on canvas",
    size: "F4, 242mm x 333mm",
    year: 2017,
  },
  "2017-35.webp": {
    title: "Present Continuous 35",
    type: "oil on canvas",
    size: "F4, 242mm x 333mm",

    year: 2017,
  },
  "2017-37.webp": {
    title: "Present Continuous 37",
    type: "oil on canvas",
    size: "F6, 318mm x 410mm",
    year: 2017,
  },
  "2017-38.webp": {
    title: "Present Continuous 38",
    type: "oil on canvas",
    size: "F6, 318mm x 410mm",
    year: 2017,
  },
  "2014-2.webp": {
    title: "Present Continuous 2",
    type: "oil on canvas",
    size: "F120, 1,303mm x 1,940mm",
    year: 2014,
  },
  "2014-5.webp": {
    title: "Present Continuous 5",
    type: "oil on canvas",
    size: "F100, 1,620mm x 1,303mm",
    year: 2014,
  },
  "2014-3.webp": {
    title: "Present Continuous 3",
    type: "oil on canvas",
    size: "S50, 1,167mm x 1,167mm",
    year: 2014,
  },
  "2014-4.webp": {
    title: "Present Continuous 4",
    type: "oil on canvas",
    size: "S50, 1,167mm x 1,167mm",

    year: 2014,
  },
  "2013-1.webp": {
    title: "Present Continuous 1",
    type: "oil on canvas",
    size: "F200, 3,240mm x 1,303mm",
    year: 2013,
  },
  "2015-10.webp": {
    title: "Present Continuous 10",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-11.webp": {
    title: "Present Continuous 11",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-12.webp": {
    title: "Present Continuous 12",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-13.webp": {
    title: "Present Continuous 13",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-14.webp": {
    title: "Present Continuous 14",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-6.webp": {
    title: "Present Continuous 6",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-8.webp": {
    title: "Present Continuous 8",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",

    year: 2015,
  },
  "2015-7.webp": {
    title: "Present Continuous 7",
    type: "oil on canvas",
    size: "F15, 652mm x 530mm",
    year: 2015,
  },
  "2015-9.webp": {
    title: "Present Continuous 9",
    type: "oil on canvas",
    size: "F10, 530mm x 455mm",
    year: 2015,
  },
  "2015-16.webp": {
    title: "Present Continuous 16",
    type: "oil on canvas",
    size: "F3, 273mm x 220mm",
    year: 2015,
  },
  "2015-15.webp": {
    title: "Present Continuous 15",
    type: "oil on canvas",
    size: "F3, 273mm x 220mm",
    year: 2015,
  },
  "2024-46.webp": {
    title: "Present Continuous 46",
    type: "oil on canvas",
    size: "F10, 455mm x 530mm",
    year: 2024,
  },
  "2023-45.webp": {
    title: "Present Continuous 45 ",
    type: "oil on canvas",
    size: "F100, 1,303mm x 1,620mm",
    year: 2023,
  },
  "2022-44.webp": {
    title: "Present Continuous 44",
    type: "oil on canvas",
    size: "F15, 530mm x 652mm",
    year: 2022,
  },
  "2020-43.webp": {
    title: "Present Continuous 43",
    type: "oil on canvas",
    size: "F20, 606mm x 727mm",
    year: 2020,
  },
  //   ".webp": {
  //     title: "Present Continuous ",
  //     type: "oil on canvas",
  //     size: "",
  //     year: 20,
  //   },
  //   ".webp": {
  //     title: "Present Continuous ",
  //     type: "oil on canvas",
  //     size: "",
  //     year: 20,
  //   },
};
